import { type Module } from "vuex";
import type {
  DefaultApi,
  JobBoardBoostCheckoutPlatformAmount,
  JobBoardBoostCheckoutStatus,
  JobBoardBoostRecommendationResponse,
} from "@/api";
import type { State as RootState } from "@/stores";

// No state: every value here is server-owned (recommendation, checkout URL, checkout status),
// so caching it in Vuex would just be a second place it could go stale.
export interface State {}

export const module: Module<State, RootState> = {
  namespaced: true,
  actions: {
    async postRecommendation(
      {},
      {
        positionId,
        budgetCents,
      }: {
        positionId: number;
        budgetCents: number;
      },
    ): Promise<JobBoardBoostRecommendationResponse> {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.postJobBoardBoostRecommendation(positionId, {
        budget_cents: budgetCents,
      });
      return response.data;
    },
    async postCheckout(
      {},
      {
        positionId,
        platforms,
        requestUuid,
        recommendationId,
      }: {
        positionId: number;
        platforms: JobBoardBoostCheckoutPlatformAmount[];
        requestUuid: string;
        recommendationId: number | null;
      },
    ): Promise<string> {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.postJobBoardBoostCheckout(positionId, {
        platforms,
        request_uuid: requestUuid,
        recommendation_id: recommendationId,
      });
      return response.data.checkout_url;
    },
    async getCheckoutConfirm(
      {},
      {
        positionId,
        sessionId,
      }: {
        positionId: number;
        sessionId: string;
      },
    ): Promise<JobBoardBoostCheckoutStatus> {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.getJobBoardBoostCheckoutConfirm(
        positionId,
        sessionId,
      );
      return response.data.checkout_status;
    },
  },
};
